import get from 'lodash/get';
import React from 'react';
import { AlgoliaSearchStateContext } from '../components/AlgoliaSearchStateProvider';
export default (function () {
  var searchState = React.useContext(AlgoliaSearchStateContext);
  return get(searchState, 'searchResults.hits') || [];
});